'use client';

import React, { ReactNode, Suspense, useEffect } from 'react';
import Toaster from '@/components/Toaster';
import useCartState from '@/stores/cart-state';
import analytics from '@/lib/analytics';
import useNewCheckoutState from '@/stores/new-checkout-state';
import { NavigationGuardProvider } from 'next-navigation-guard';

type Props = {
  children?: ReactNode;
};

const AppClientRoot: React.FC<Props> = ({ children }) => {
  useEffect(() => {
    useCartState.persist.rehydrate();
  }, []);

  useEffect(() => {
    useNewCheckoutState.persist.rehydrate();
  }, []);

  useEffect(() => {
    analytics.init();
  }, []);

  return (
    <NavigationGuardProvider>
      <Suspense>
        <Toaster />
      </Suspense>
      {children ?? null}
    </NavigationGuardProvider>
  );
};

export default AppClientRoot;
